import {
  IInquiryList, IRequestSearchInquiry, IResReasonSubmit, IInquiryReason,
} from 'pages/reservationInquiryList/type';
import ApiClient from './ApiClient';

export const getInquiryApi = async (params: IRequestSearchInquiry): Promise<IInquiryList> => {
  const { data } = await ApiClient.get('/v1/reservationInquiry', params);
  return data;
};
export default getInquiryApi;


export const getInquiryListCsvApi = async (fileName: string, queryString: string): Promise<void> => {
  await ApiClient.downloadCsv('/v1/reservationInquiry/csv', {}, fileName, queryString);
};

export const getInquiryReasonApi = async (): Promise<IInquiryReason[]> => {
  const { data } = await ApiClient.get('/v1/reservationInquiryReason', {});
  return data;
};

export const updateInquiryApi = async (params: IResReasonSubmit): Promise<void> => {
  const { data } = await ApiClient.putJsonData('/v1/reservationInquiry', {}, params);
  return data;
};

export const getReservationInquiryCountApi = async (): Promise<{ unregisteredCount: number }> => {
  const { data } = await ApiClient.get('/v1/reservationInquiry/count', {});
  return data;
};

export const getOldestUnregisteredInquiryDateApi = async (): Promise<{ oldestUnregisteredDate: string | null }> => {
  const { data } = await ApiClient.get('/v1/reservationInquiry/oldestUnregisteredDate', {});
  return data;
};
